import { Button } from '@app/components/various/Button';
import { CheckboxGroup } from '@app/components/various/CheckboxGroup';
import { Checkbox } from '@app/components/various/Fields/Checkbox';
import { Filters } from '@app/components/various/Icons';
import { Popover } from '@app/components/various/Popover';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectionOverviewContext } from '../SelectionOverviewContext';

import styles from './VariantsFilters.module.scss';

export const VariantsFilters = () => {
  const { rowFilterOptions, shouldShowWithUnits, setShouldShowWithUnits, rowFilterOptionsState, toggleRowFilterOptionsState } =
    React.useContext(SelectionOverviewContext);
  const { t } = useTranslation(['common', 'selectionOverview']);

  const toggleShouldShowWithUnits = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setShouldShowWithUnits(!event.target.checked);
    },
    [setShouldShowWithUnits],
  );

  const mainCategories = rowFilterOptions.filter(option => !isDefined(option.parentValue));
  const mainSelectedCategories = mainCategories.filter(option => rowFilterOptionsState[option.value] === 'checked');
  const hasFilteringOptions = !isEmpty(rowFilterOptions);

  return (
    <>
      <div className={styles.filtersOption}>
        <Checkbox isChecked={!shouldShowWithUnits} onChange={toggleShouldShowWithUnits}>
          {t('selectionOverview:show_variants_without_units')}
        </Checkbox>
      </div>
      <div className={cx(styles.filtersOption, styles.rowsFilter)}>
        <Popover
          isEnabled={hasFilteringOptions}
          isClickable
          placement="bottom-end"
          className="min-w-48"
          content={
            <div className="overflow-hidden">
              <CheckboxGroup options={rowFilterOptions} optionsState={rowFilterOptionsState} onChange={toggleRowFilterOptionsState} />
            </div>
          }
          contentHeader={t('common:filter_other')}
        >
          {({ isVisible }) => (
            <Button
              size="medium"
              disabled={!hasFilteringOptions}
              variant="bordered"
              color="secondary"
              icon={Filters}
              isChevronOpen={isVisible}
            >
              {isEmpty(mainSelectedCategories) ? t('common:all') : `${mainSelectedCategories.length}/${mainCategories.length}`}
            </Button>
          )}
        </Popover>
      </div>
    </>
  );
};
